import { withFormik } from 'formik';
import { defaultFormSubmit } from 'src/utils/form/submit';
import UserForm from './UserForm';
import schema from './schema';

export default withFormik({
  validationSchema: schema.validation,
  // enableReinitialize: true,
  mapPropsToValues: ({ user }) => {
    return {
      id: user.id,
      firstName: user.firstName || '',
      lastName: user.lastName || '',
      email: user.email || '',
      login: user.login || '',
      roles: (user.roles && user.roles.map(r => ({ value: r.id, label: r.name, isDisabled: !!r.deletedAt }))) || [],
      filteringRuleGroups: (user.filteringRuleGroups && user.filteringRuleGroups.map(r => ({ value: r.id, label: r.name, isDisabled: !!r.deletedAt }))) || [],
      timezoneId: user.timezoneId,
      active: (user.active === undefined) ? true : user.active,
      isThirdPartyUser: user.isThirdPartyUser ? user.isThirdPartyUser : false,
      desktopVersion: user.desktopVersion,
      mobileAppVersion: user.mobileAppVersion,
      mobileDeviceInfo: user.mobileDeviceInfo,
    };
  },
  handleSubmit: (values, form) => {
    return defaultFormSubmit(values, form, schema.requireValues);
  },
  displayName: 'UserForm',
})(UserForm);
